import React from "react";
import { FC} from 'react' 
import { Typography } from "@material-ui/core";
import { Trans } from "react-i18next";

interface Props {
  text?: string,
} 

const defaultProps: Props = {
  text: "brak wyników do wyświetlenia",
}

export const NoResult: FC<Props> = ({text}) => {

  return (
    <div style={{ minHeight: "200px", margin: "auto" }}>
      <Typography variant="h6" component="h2" color="primary" style={{ padding: "50px", textAlign: "center", fontSize: "1rem", transform: "rotate(-22deg)", opacity: "0.7" }}>
        <b>{text}</b>
      </Typography>
    </div>
  );
}

NoResult.defaultProps = defaultProps;
